import moment from 'moment';

import { DATE_FORMAT } from '@/consts';
import { normalizeText } from '@/helpers';

import {
  APPLY_FILTERS,
  CLEAR_FILTERS,
  SET_ITEMS,
  FILTER_ITEMS,
  SET_TARGETING_ITEM,
  SET_SUMMARY,
  SET_APPEND,
  SET_LOADING,
  RESET
} from './types';

const now = moment();

export const INIT_STATE = {
  filters: {
    page: 1,
    pageSize: 20,
    fromDate: moment(`${now.year()}-${(now.month() + 1)}-01`).format(DATE_FORMAT),
    toDate: moment().format(DATE_FORMAT),
    minAmount: '',
    maxAmount: '',
    funds: null,
    types: null,
    directions: null,
    categories: null,
    search: null,
  },
  items: [],
  storedItems: [],
  total: 0,
  isAppending: false,
  isLoading: false,
  summary: {
    totalCashIn: 0,
    totalCashOut: 0,
    bankBalance: 0,
    cashBalance: 0
  },
  targetingItem: null
};

const mutations = {
  [APPLY_FILTERS](state, filters) {
    state.filters = {
      ...state.filters,
      ...filters
    };
  },

  [SET_APPEND](state, val) {
    state.isAppending = val || false;
  },

  [SET_LOADING](state, val) {
    state.isLoading = val || false;
  },

  [CLEAR_FILTERS](state) {
    state.filters = { ...INIT_STATE.filters };
  },

  [SET_ITEMS](state, { items, total }) {
    if (state.isAppending) {
      state.items = [
        ...items,
        ...state.items
      ];
    } else {
      state.items = [...items];
    }

    state.storedItems = [...state.items];
    state.total = total;
  },

  [FILTER_ITEMS](state) {
    const { minAmount, maxAmount, funds, types, directions, categories, search } = state.filters;
    let items = [...state.storedItems];

    if (minAmount) {
      items = items.filter((item) => (item.amount >= minAmount));
    }

    if (maxAmount) {
      items = items.filter((item) => (item.amount <= maxAmount));
    }

    if (funds) {
      items = items.filter((item) => (funds.indexOf(item.fund?.id) >= 0));
    }

    if (types) {
      items = items.filter((item) => (types.indexOf(item.type) >= 0));
    }

    if (directions) {
      items = items.filter((item) => (directions.indexOf(item.direction) >= 0));
    }

    if (categories) {
      items = items.filter((item) => (categories.indexOf(item.category.id) >= 0));
    }

    if (search) {
      const normalizeSearch = normalizeText(search);
      items = items.filter((item) => (item.mifosLoanId === parseInt(search, 10) || normalizeText(item.notes).includes(normalizeSearch)));
    }

    state.items = items;
  },

  [SET_TARGETING_ITEM](state, { item }) {
    state.targetingItem = item || null;
  },

  [SET_SUMMARY](state, { summary }) {
    state.summary = { ...summary };
  },

  [RESET](state) {
    const { summary } = state;

    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });

    state.summary = summary;
  }
};

export default mutations;
